import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function login(username, password,key,code) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      userName: username,
      passWord: password,
      key,
      code
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'post',
    data: {
      token: getToken()
    }
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'post',
    data: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/add',
    method: 'post',
    data: data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/admin/edit',
    method: 'post',
    data: data
  })
}

export function updateStatus(data) {
  return request({
    url: '/admin/edit',
    method: 'post',
    data: data
  })
}

export function deleteAdmin(data) {
  return request({
    url: '/admin/delete',
    method: 'post',
    data: data
  })
}

export function getRoleByAdmin(data) {
  return request({
    url: '/admin_role_relation/list',
    method: 'post',
    data: data
  })
}

export function allocRole(data) {
  return request({
    url: '/admin_role_relation/replace',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js